export class Login {
    constructor(
      public id?: number,
      public email?: string,
      public password?: string,
      public user_name?:string,
    ) {
      this.id = id;
      this.password = password;
      this.email = email;
      this.user_name = user_name;
    }
  }